import localeModule from 'timeago.js/lib/lang/de'
const localeName = 'de'
export default { locale: localeName, module: localeModule }
